import { useCallback, useState } from "react";
import { NMWaitIndicator } from "@neumetric/blueprint-lib/components";
import { InvestigatorSeverityStats } from "./SeverityWiseIncident";
import { InvestigatorDepartmentStats } from "./DepartmentWiseIncident";

export function InvestigatorStats(props) {
  const {
    user,
    severities,
    departments,
    imageSrc,
    dateRangeList,
    dateRange,
    mode,
  } = props;
  const [loadedRanges, setLoadedRanges] = useState({});
  const effectiveRangeId =
    typeof dateRange === "string" ? dateRange : dateRange?.id || "last_365_days";
  const showDepartmentStats = mode === "full" || mode === "export_everything";
  const isLoading =
    loadedRanges.severity !== effectiveRangeId ||
    (showDepartmentStats && loadedRanges.department !== effectiveRangeId);
  const handleSeverityLoaded = useCallback((rangeId) => {
    setLoadedRanges((current) => ({ ...current, severity: rangeId }));
  }, []);
  const handleDepartmentLoaded = useCallback((rangeId) => {
    setLoadedRanges((current) => ({ ...current, department: rangeId }));
  }, []);

  const Field = { attribute: "dateRange", type: "select" };
  const Columns = [
    {
      title: "",
      attribute: "label",
      width: "16%",
    },
    {
      title: "Max Aging",
      attribute: "max_aging",
      classes: { color: "text-filled" },
      highlight: { header: true, cell: false },
    },
    {
      title: "Avg Aging",
      attribute: "avg_aging",
      classes: { color: "text-filled" },
      highlight: { header: true, cell: false },
    },
    {
      title: "OVERALL",
      attribute: "total",
      id: "Overall",
      highlight: { header: true, cell: true },
      overallFlag: true,
    },
    {
      title: "Closed",
      attribute: "COMPLETE",
      id: "COMPLETE",
    },
    {
      title: "Started",
      attribute: "STARTED",
      id: "STARTED",
    },
    {
      title: "Open",
      attribute: "OPEN",
      id: "PENDING",
    },
    {
      title: "Other",
      attribute: "OTHER",
      id: "INVALID",
    },
  ];

  return (
    <div className="o-auto">
      <div style={{ display: isLoading ? "none" : undefined }}>
        <InvestigatorSeverityStats
          Field={Field}
          Columns={Columns}
          user={user}
          severities={severities}
          imageSrc={imageSrc}
          dateRange={dateRange}
          dateRangeList={dateRangeList}
          mode={mode}
          onDataLoaded={handleSeverityLoaded}
        />
        {showDepartmentStats && (
          <>
            <InvestigatorDepartmentStats
              Field={Field}
              Columns={Columns}
              user={user}
              departments={departments}
              imageSrc={imageSrc}
              dateRange={dateRange}
              dateRangeList={dateRangeList}
              onDataLoaded={handleDepartmentLoaded}
            />
            <div style={{ paddingTop: "100px" }}>
              <hr className="nm-hr nm-hr--center" />
            </div>
          </>
        )}
      </div>
      {isLoading && <NMWaitIndicator />}
    </div>
  );
}
